var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-pdf"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"pdf_box",style:({width:_vm.pdfWidth}),attrs:{"element-loading-text":"加载中..."}},_vm._l((_vm.pdfPages),function(page){return _c('canvas',{key:page,attrs:{"id":'pdfCanvas' + page}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }